/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import store from '../../../store/store.js'



const menuItem = [
  {
    url: '/',
    name: 'Home',
    slug: 'Dashboard',
    icon: 'HomeIcon',
    role: ['ADMIN', 'REVIEW', 'VIEW_ONLY']
  },
  {
    url: '/analytics',
    name: 'Analytics',
    slug: 'Analytics',
    icon: 'ActivityIcon',
    role: ['VIEW_ONLY']
  },
  {
    url: '/footfall',
    name: 'Footfall',
    slug: 'Footfall',
    icon: 'Link2Icon',
    role: ['VIEW_ONLY']
  },
  {
    url: '/application',
    name: 'Application',
    slug: 'proposal',
    icon: 'TrelloIcon',
    role: ['REVIEW']
  },
  {
    url: '/search-application',
    name: 'Application',
    slug: 'proposal',
    icon: 'TrelloIcon',
    role: ['VIEW_ONLY']
  },
  {
    url: '/applicant-list',
    name: 'Applicant List',
    slug: 'applicant-list',
    icon: 'UserCheckIcon',
    role: ['REVIEW']
  },
  {
    url: '/guarantor-list',
    name: 'Guarantor List',
    slug: 'guarantor-list',
    icon: 'CheckCircleIcon',
    role: ['REVIEW']
  },
  // {
  //   url: '/compare-app',
  //   name: 'Compare Application',
  //   slug: 'compare-app',
  //   icon: 'ActivityIcon',
  //   role: ['REVIEW']
  // },
  {
    url: '/compare-application',
    name: 'Compare Application',
    slug: 'compare-app',
    icon: 'ActivityIcon',
    role: ['REVIEW']
  },
  // {
  //   url: '/profile-update',
  //   name: 'Profile Update',
  //   slug: 'profile-update',
  //   icon: 'PenToolIcon',
  //   role: ['REVIEW']
  // },
  {
    url: '/profile-update-new',
    name: 'Profile Update (New)',
    slug: 'profile-update-new',
    icon: 'PenToolIcon',
    role: ['REVIEW']
  },
/*  {
    url: '/change-request',
    name: 'Change Request',
    slug: 'change-request',
    icon: 'OctagonIcon',
    role: ['REVIEW']
  },*/
  {
    url: '/report',
    name: 'Report',
    slug: 'report',
    icon: 'PieChartIcon',
    role: ['REVIEW']
  },
  {
    url: '/agreementReport',
    name: 'Agreement Report',
    slug: 'agreementReport',
    icon: 'PieChartIcon',
    role: ['REVIEW','VIEW_ONLY']
  },
  {
    url: '/purchase-history',
    name: 'Purchase History',
    slug: 'purchaseHistory',
    icon: 'UserIcon',
    role: ['REVIEW']
  },
  {
    url: '/nid-validated-applicant',
    name: 'Nid Validated Applicant',
    slug: 'nidValidatedApplicant',
    icon: 'UserIcon',
    role: ['REVIEW']
  },
  {
    url: '/showroom',
    name: 'Showroom',
    slug: 'showroom',
    icon: 'ServerIcon',
    role: ['ADMIN']
  },
  {
    url: '/users',
    name: 'Users',
    slug: 'users',
    icon: 'UsersIcon',
    role: ['ADMIN']
  },
  {
    url: '/settings',
    name: 'Master Data',
    slug: 'settings',
    icon: 'SettingsIcon',
    role: ['ADMIN']
  },
  {
    url: '/try_and_buy',
    name: 'Try & Buy',
    slug: 'try_and_buy',
    icon: 'PackageIcon',
    role: ['WM_VIEW']
  },
  {
    url: '/find-agreement',
    name: 'Find Agreement',
    slug: 'find_agreement',
    icon: 'PackageIcon',
    role: ['REVIEW']
  }
]

export default menuItem.filter(m => m.role.includes(store.getters.appActiveUserROle))
